import { useEffect, useState } from 'react';

import type { RadioGroupOption } from '../RadioGroup/RadioGroup';
import { RadioGroup } from '../RadioGroup/RadioGroup';
import { FilterPopover } from './FilterPopover';

interface RadioGroupFilterPopoverProps<T extends string> {
  triggerElement: React.ReactNode;
  label?: string;
  value: T;
  options: RadioGroupOption<T>[];
  open?: boolean;
  onChange: (value: T) => void;
  onClose?: () => void;
}

export function RadioGroupFilterPopover<T extends string>({
  triggerElement,
  label,
  value,
  options,
  open,
  onChange,
  onClose,
}: RadioGroupFilterPopoverProps<T>) {
  const [activeValue, setActiveValue] = useState(value);

  useEffect(() => {
    setActiveValue(value);
  }, [value]);

  return (
    <FilterPopover
      open={open}
      triggerElement={triggerElement}
      onApply={() => {
        onChange(activeValue);
      }}
      onCancel={() => {
        // Reset state
        setActiveValue(value);
        onClose?.();
      }}
      onOpenChange={(isOpen) => {
        if (!isOpen) {
          setActiveValue(value);
          onClose?.();
        }
      }}
    >
      <RadioGroup
        label={label ?? ''}
        value={activeValue}
        options={options}
        onChange={setActiveValue}
      />
    </FilterPopover>
  );
}
